var _circle, _circle2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#826DD4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 20,
    fill: "#826DD4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 43C44.4183 43 48 39.4183 48 35C48 30.5817 44.4183 27 40 27C35.5817 27 32 30.5817 32 35C32 39.4183 35.5817 43 40 43Z",
    fill: "#D7C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 47C34.2764 47 29.3551 50.4346 27.1846 55.3553C30.6552 58.2549 35.1238 60 40 60C44.8762 60 49.3448 58.2549 52.8154 55.3553C50.6449 50.4346 45.7236 47 40 47Z",
    fill: "#D7C3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.9226733cff1b52d0c59fd77c01d0996a.svg";
export { ForwardRef as ReactComponent };